import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/forge/www.medkart.in/releases/82082909/components/MainComponent/MainComponent.tsx");
